import { action } from 'mobx';
import config from 'config';
import HttpClient from 'utils/httpclient';
import BaseStore from 'stores/BaseStore';

class UserProfileStore extends BaseStore {
  constructor () {
    super('user-profiles', 'user-profile', { site_model: true });
  }

  @action getFields () {
    return HttpClient.get(`${config.api}/site/${this.getCurrentSiteID()}/getFields`)
      .then(action(response => {
        return response.data;
      }));
  }
}

export default new UserProfileStore();
